module.exports = __webpack_public_path__ + "img/2f9ba9b.png";